import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]

  static values = { default: { type: String, default: "url" } }

  connect() {
    const urlTab = new URLSearchParams(window.location.search).get("tab")
    this.showPanel(urlTab || this.defaultValue)
  }

  switch(event) {
    this.showPanel(event.currentTarget.dataset.panel)
  }

  showPanel(name) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.panel !== name)
    })

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.panel === name
      this.activeClasses.forEach(cls => tab.classList.toggle(cls, isActive))
      this.inactiveClasses.forEach(cls => tab.classList.toggle(cls, !isActive))
    })
  }
}
